import { useRef, useState } from 'react';
import ReactQuill from 'react-quill';
import { API_URL } from '../Api';
import TwButton from '../controls/button';
import FormLabel from '../controls/formLabel';
import TwCheck from '../controls/input.check';
import TwInputDate, { TwInputDateTime } from '../controls/input.date';
import TwInputSelect from '../controls/input.select';
import TwInputText from '../controls/input.text';
import { Paragraph, Title } from './Display';
import { Grid, GridColumn, LeftComponents } from './Layout';
import './richtext.scss';


export const ConfirmForm = ({ title, text, onConfirm, onCancel }) => {
  return <>
    <Title>{title}</Title>
    <Paragraph>{text}</Paragraph>
    <LeftComponents>
      <TwButton onClick={onCancel}>انصراف</TwButton>
      <TwButton onClick={onConfirm}>تایید</TwButton>
    </LeftComponents>
  </>
}

export const MultiSelectBox = ({ value, onChange, label, options }) => {
  // const [options, setOptions] = useState([]);
  const onChangeSelect = (e) => {
    if (e.length > 0) {
      onChange(e.map((item) => item.toString()).join(','));
    }
    else {
      onChange(null);
    }
  }
  var valueArray = value || [];
  if (typeof valueArray === "string") {
    valueArray = valueArray.split(",").map(Number);
  }
  return <div className="mb-4">
    <FormLabel>{label}</FormLabel>
    <TwInputSelect options={options} value={valueArray} onChange={onChangeSelect} multiSelect={true} />
  </div>
};

export const SearchBox = ({ label, value, onChange, width, onEnter }) => {
  const onChangeText = (e) => {
    onChange(e.target.value);
  }
  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      onEnter();
    }
  }
  return <div className="mb-4">
    <FormLabel>{label}</FormLabel>
    <TwInputText
      value={value}
      onChange={onChangeText}
      placeholder={''}
      width={width}
      onKeyDown={onKeyDown}
    />
  </div>
}

export const Button = ({ color, rightIcon = '', leftIcon = '', tooltip = '', onClick, children, disabled = false }) => (
  <TwButton
    color={color}
    rightIcon={rightIcon}
    leftIcon={leftIcon}
    tooltip={tooltip}
    onClick={onClick}
    disabled={disabled}
  >
    {children}
  </TwButton>
);

export const DataForm = ({ className = '', children, ...props }) => (
  <div className={`${className}`} {...props}>
    {children}
  </div>
);

export const RichTextView = ({ className = '', ...props }) => (
  <div className={`${className}`} {...props} />
);

export const TextBox = ({ value, onChange, label, onKeyDown, onEnter }) => {
  const onChangeText = (e) => {
    if (e.target.value.length > 0) {
      onChange(e.target.value);
    }
    else {
      onChange(null);
    }
  }
  const onKeyDownHandler = (e) => {
    if (e.key === 'Enter') {
      onEnter();
    }
    if (onKeyDown !== undefined) {
      onKeyDown(e);
    }
  }
  return <div className="mb-4">
    <FormLabel>{label}</FormLabel>
    <TwInputText
      value={value || ''}
      onChange={onChangeText}
      placeholder={''}
      onKeyDown={onKeyDownHandler}
    />
  </div>
}


export const Password = ({ value, onChange, label }) => {
  const [password, setPassword] = useState(value);
  const onChangePassword = (e) => {
    if (e.target.value.length > 0) {
      setPassword(e.target.value);
      onChange(e.target.value);
    }
    else {
      setPassword('');
      onChange('');
    }
  }
  return <div className="mb-4">
    <FormLabel>{label}</FormLabel>
    <TwInputText
      value={password || ''}
      onChange={onChangePassword}
      placeholder={''}
      type="password"
    />
  </div>
}

export const CheckBox = ({ value, onChange, label, error }) => {
  const onChangeCheck = (e) => {
    onChange(e.target.checked);
  }
  return <div className="mb-4">
    <FormLabel>{label}</FormLabel>
    <TwCheck
      checked={value}
      onChange={onChangeCheck}
    />
    {error && <div className="text-red-500">{error}</div>}
  </div>
}

export const RichText = ({ label, value, onChange }) => {
  // const EditorRef = useRef(null);
  // const [toolbar, toggleToolbar] = useReducer((state, action) => { return Boolean(!state) }, false);
  // const addProp = () => {
  //     const selection = EditorRef.current.editor.getSelection();
  //     component.childPageDialog(
  //         'select-prop',
  //         {},
  //         (result) => {
  //             if (result && result.save) {
  //                 insertFromSource(EditorRef.current.editor, selection, result.data.prop);
  //             }
  //         }
  //     );
  // }
  // const toolbarId = `toolbar${component.info.id.replace('.', '_')}`;
  // const modules = {
  //     toolbar: {
  //         container: '#'+toolbarId,
  //         component: component,
  //         handlers: {
  //             insertIcon: insertIcon,
  //             insertFromSource: insertFromSourceC
  //         },
  //     }
  // };
  if (typeof value === 'string') {
    if (value.startsWith('{')) {
      value = JSON.parse(value);
    }
    else {
      value = { document: {} };
    }
  }
  if (value === null) {
    value = { document: {} };
  }
  const valueChanged = (content, delta, source, editor) => {
    onChange(JSON.stringify({ type: "quill", document: editor.getContents() }))
  }

  return <div className="mb-4">
    <FormLabel>{label}</FormLabel>
    <div className={`ltr ql-editor-lines-10`}>
      {/* <div id={toolbarId} style={{ display: toolbar ? 'block' : 'none' }}>
        {component.repository && <button className="ql-insertFromSource lh-1"   >
          <span className="far fa-bolt"></span>
        </button>}
        <button className="ql-bold"   >Bold</button>
        <button className="ql-italic"   ></button>
        <button className="ql-image"   ></button>
        <button className="ql-align" value="right"   ></button>
        <button className="ql-align" value="center"   ></button>
        <button className="ql-align" value=""   ></button>
        <button className="ql-align" value="justify"   ></button>
        <select className="ql-color" defaultValue={0}>
          <option value="red"></option>
          <option value="green"></option>
          <option value="blue"></option>
          <option value="orange"></option>
          <option value="violet"></option>
          <option value="#d0d1d2"></option>
          <option value={0}></option>
        </select>
        <select className="ql-size" defaultValue={0}>
          <option value="small">کوچک</option>
          <option value={0}>نرمال</option>
          <option value="large">بزرگ</option>
          <option value="huge">بزرگتر</option>
        </select>
        <select className="ql-header" defaultValue={0}>
          <option value={0}>متن معمولی</option>
          <option value="1">عنوان اصلی</option>
          <option value="2">عنوان فرعی</option>
          <option value="3">عنوان فرعی 2</option>
          <option value="4">عنوان فرعی 3</option>
        </select>
      </div> */}
      <ReactQuill
        height={"200px"}
        // modules={modules}
        // ref={EditorRef}
        theme="snow"
        value={value.document}
        onChange={valueChanged}
      />
    </div>
  </div>
}

export const RelationList = ({ label }) => (
  <div className="mb-4">
    <FormLabel>{label}</FormLabel>
    {/* <TwInputSelect options={options} value={value} onChange={onChangeSelect} /> */}
  </div>
);

export const RelationCheckboxes = ({ label, options, value, onChange }) => {
  const changeValue = (e, id) => {
    const newValue = e.target.checked ? [...value, id] : value.filter((item) => item !== id);
    onChange(newValue);
  }
  return (
    <div className="mb-4">
      <FormLabel>{label}</FormLabel>
      <Grid>
        {options?.map((option) => <GridColumn key={option.id} width={6}>
          <TwCheck label={option.title} checked={value.includes(option.id)} onChange={(e) => changeValue(e, option.id)} />
        </GridColumn>)}
      </Grid>
    </div>
  );
}

export const RelationTable = ({ label }) => (
  <div className="mb-4">
    <FormLabel>{label}</FormLabel>
    {/* <TwInputSelect options={options} value={value} onChange={onChangeSelect} /> */}
  </div>
);

// Add new components for progress and preview
const ProgressBar = ({ progress }) => (
  <div className="w-full bg-gray-200 rounded-full h-2.5 my-2">
    <div
      className="bg-blue-600 h-2.5 rounded-full transition-all duration-300 ease-in-out"
      style={{ width: `${progress}%` }}
    />
  </div>
);

const FilePreview = ({ file, onClear }) => (
  <div className="mt-2 p-3 bg-gray-50 rounded-lg border border-gray-200 flex items-center justify-between">
    <div className="flex items-center space-x-2">
      <span className="text-blue-600">
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      </span>
      <div className="text-sm">
        <p className="font-medium text-gray-900">{file.name}</p>
        <p className="text-gray-500">{(file.size / 1024).toFixed(1)} KB</p>
      </div>
    </div>
    <button
      onClick={onClear}
      className="text-gray-400 hover:text-red-500 transition-colors"
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>
);

const ImagePreview = ({ file, src, onClear }) => (
  <div className="mt-2 p-3 bg-gray-50 rounded-lg border border-gray-200">
    <div className="flex items-center justify-between mb-2">
      <div className="flex items-center space-x-2">
        <span className="text-blue-600">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
        </span>
        <div className="text-sm">
          <p className="font-medium text-gray-900">{file?.name}</p>
          <p className="text-gray-500">{file && (file.size / 1024).toFixed(1)} KB</p>
        </div>
      </div>
      <button
        onClick={onClear}
        className="text-gray-400 hover:text-red-500 transition-colors"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
    <img
      src={src}
      alt="Preview"
      className="w-full h-48 object-cover rounded-md"
    />
  </div>
);

const AudioPreview = ({ file, src, onClear }) => (
  <div className="mt-2 p-3 bg-gray-50 rounded-lg border border-gray-200">
    <div className="flex items-center justify-between mb-2">
      <div className="flex items-center space-x-2">
        <span className="text-blue-600">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
          </svg>
        </span>
        <div className="text-sm">
          <p className="font-medium text-gray-900">{file?.name}</p>
          <p className="text-gray-500">{file && (file.size / 1024).toFixed(1)} KB</p>
        </div>
      </div>
      <button
        onClick={onClear}
        className="text-gray-400 hover:text-red-500 transition-colors"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
    <audio controls className="w-full">
      <source src={src} />
      Your browser does not support the audio element.
    </audio>
  </div>
);

export const FileUpload = ({ value, onChange, label, uploadApi }) => {
  const [uploadProgress, setUploadProgress] = useState(0);
  const [currentFile, setCurrentFile] = useState(null);
  const inputRef = useRef(null);

  const fileUploaded = (filename) => {
    onChange(JSON.stringify({ filename: filename }));
  }
  let valueJson = value;
  if (typeof value === 'string') {
    valueJson = JSON.parse(value);
  }

  const handleClear = () => {
    setCurrentFile(null);
    setUploadProgress(0);
    onChange(null);
    if (inputRef.current) {
      inputRef.current.value = '';
    }
  }

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setCurrentFile(file);
    setUploadProgress(0);

    try {
      const formData = new FormData();
      formData.append('file', file);


      const xhr = new XMLHttpRequest();
      xhr.upload.addEventListener('progress', (event) => {
        if (event.lengthComputable) {
          const progress = Math.round((event.loaded * 100) / event.total);
          setUploadProgress(progress);
        }
      });

      xhr.onload = () => {
        if (xhr.status === 200) {
          const response = JSON.parse(xhr.responseText);
          if (response.success) {
            fileUploaded(response.filename);
          }
        }
      };

      xhr.onerror = () => {
        console.error('Upload error');
        setUploadProgress(0);
      };

      xhr.open('POST', uploadApi);

      const token = localStorage.getItem('admin_auth_token');
      if (token) {
        xhr.setRequestHeader('Auth-Token', token);
      }

      xhr.send(formData);
    } catch (error) {
      console.error('Upload error:', error);
      setUploadProgress(0);
    }
  }

  return (
    <div className="mb-4">
      <FormLabel>{label}</FormLabel>
      <div className="mt-1">
        <div className="flex items-center justify-center w-full">
          <label className="flex flex-col w-full h-32 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
            <div className="flex flex-col items-center justify-center pt-7">
              <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
              </svg>
              <p className="pt-1 text-sm text-gray-600">Drag & drop or click to select</p>
            </div>
            <input
              ref={inputRef}
              type="file"
              className="opacity-0"
              onChange={handleFileChange}
            />
          </label>
        </div>
      </div>

      {uploadProgress > 0 && uploadProgress < 100 && (
        <ProgressBar progress={uploadProgress} />
      )}

      {(currentFile || valueJson?.filename) && (
        <FilePreview
          file={currentFile || { name: valueJson?.filename }}
          onClear={handleClear}
        />
      )}
    </div>
  );
}

export const PictureUpload = ({ value, onChange, label }) => {
  const [uploadProgress, setUploadProgress] = useState(0);
  const [currentFile, setCurrentFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const inputRef = useRef(null);

  const fileUploaded = (filename) => {
    onChange(JSON.stringify({ filename: filename }));
  }
  let valueJson = value;
  if (typeof value === 'string') {
    valueJson = JSON.parse(value);
  }
  const handleClear = () => {
    setCurrentFile(null);
    setPreviewUrl(null);
    setUploadProgress(0);
    onChange(null);
    if (inputRef.current) {
      inputRef.current.value = '';
    }
  }

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      alert('Please select an image file');
      return;
    }

    setCurrentFile(file);
    setUploadProgress(0);

    // Create preview URL
    const reader = new FileReader();
    reader.onloadend = () => {
      setPreviewUrl(reader.result);
    };
    reader.readAsDataURL(file);

    try {
      const formData = new FormData();
      formData.append('file', file);

      const xhr = new XMLHttpRequest();
      xhr.upload.addEventListener('progress', (event) => {
        if (event.lengthComputable) {
          const progress = Math.round((event.loaded * 100) / event.total);
          setUploadProgress(progress);
        }
      });

      xhr.onload = () => {
        if (xhr.status === 200) {
          const response = JSON.parse(xhr.responseText);
          if (response.success) {
            fileUploaded(response.filename);
          }
        }
      };

      xhr.onerror = () => {
        console.error('Upload error');
        setUploadProgress(0);
      };

      xhr.open('POST', `${API_URL}/api/files/upload`);

      const token = localStorage.getItem('admin_auth_token');
      if (token) {
        xhr.setRequestHeader('Auth-Token', token);
      }

      xhr.send(formData);
    } catch (error) {
      console.error('Upload error:', error);
      setUploadProgress(0);
    }
  }

  return (
    <div className="mb-4">
      <FormLabel>{label}</FormLabel>
      <div className="mt-1">
        <div className="flex items-center justify-center w-full">
          <label className="flex flex-col w-full h-32 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
            <div className="flex flex-col items-center justify-center pt-7">
              <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              <p className="pt-1 text-sm text-gray-600">Drag & drop image or click to select</p>
            </div>
            <input
              ref={inputRef}
              type="file"
              accept="image/*"
              className="opacity-0"
              onChange={handleFileChange}
            />
          </label>
        </div>
      </div>

      {uploadProgress > 0 && uploadProgress < 100 && (
        <ProgressBar progress={uploadProgress} />
      )}

      {(previewUrl || valueJson?.filename) && (
        <ImagePreview
          file={currentFile}
          src={previewUrl || `${API_URL}/uploads/${valueJson?.filename}`}
          onClear={handleClear}
        />
      )}
    </div>
  );
}

export const AudioUpload = ({ value, onChange, label }) => {
  const [uploadProgress, setUploadProgress] = useState(0);
  const [currentFile, setCurrentFile] = useState(null);
  const inputRef = useRef(null);

  const fileUploaded = (filename) => {
    onChange(JSON.stringify({ filename: filename }));
  }
  const valueJson = value ? JSON.parse(value) : null;

  const handleClear = () => {
    setCurrentFile(null);
    setUploadProgress(0);
    onChange(null);
    if (inputRef.current) {
      inputRef.current.value = '';
    }
  }

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith('audio/')) {
      alert('Please select an audio file');
      return;
    }

    setCurrentFile(file);
    setUploadProgress(0);

    try {
      const formData = new FormData();
      formData.append('file', file);

      const xhr = new XMLHttpRequest();
      xhr.upload.addEventListener('progress', (event) => {
        if (event.lengthComputable) {
          const progress = Math.round((event.loaded * 100) / event.total);
          setUploadProgress(progress);
        }
      });

      xhr.onload = () => {
        if (xhr.status === 200) {
          const response = JSON.parse(xhr.responseText);
          if (response.success) {
            fileUploaded(response.filename);
          }
        }
      };

      xhr.onerror = () => {
        console.error('Upload error');
        setUploadProgress(0);
      };

      xhr.open('POST', `${API_URL}/api/files/upload`);

      const token = localStorage.getItem('admin_auth_token');
      if (token) {
        xhr.setRequestHeader('Auth-Token', token);
      }

      xhr.send(formData);
    } catch (error) {
      console.error('Upload error:', error);
      setUploadProgress(0);
    }
  }

  return (
    <div className="mb-4">
      <FormLabel>{label}</FormLabel>
      <div className="mt-1">
        <div className="flex items-center justify-center w-full">
          <label className="flex flex-col w-full h-32 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
            <div className="flex flex-col items-center justify-center pt-7">
              <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
              </svg>
              <p className="pt-1 text-sm text-gray-600">Drag & drop audio or click to select</p>
            </div>
            <input
              ref={inputRef}
              type="file"
              accept="audio/*"
              className="opacity-0"
              onChange={handleFileChange}
            />
          </label>
        </div>
      </div>

      {uploadProgress > 0 && uploadProgress < 100 && (
        <ProgressBar progress={uploadProgress} />
      )}

      {(currentFile || valueJson?.filename) && (
        <AudioPreview
          file={currentFile}
          src={`${API_URL}/uploads/${valueJson?.filename}`}
          onClear={handleClear}
        />
      )}
    </div>
  );
}

export const DataSelect = ({ options, value, onChange, label }) => {
  // const [selected, setSelected] = useState(value);
  // const onChangeSelect = (value) => {
  //   if (value !== null) {
  //     // setSelected(value);
  //     onChange(value);
  //   }
  //   else {
  //     // setSelected(null);
  //     onChange(null);
  //   }
  // }
  return <div className="mb-4">
    <FormLabel>{label}</FormLabel>
    <TwInputSelect options={options} value={value} onChange={onChange} />
  </div>
}

export const LabeledTextView = ({ label, children }) => {
  return <div className="mb-4">
    <FormLabel>{label}</FormLabel>
    {children}
  </div>
}

export const DatePicker = ({ label, value, onChange }) => {
  return <div className="mb-4">
    <FormLabel>{label}</FormLabel>
    <TwInputDate value={value} onChange={onChange} />
  </div>
}

export const DateTimePicker = ({ label, value, onChange }) => {
  return <div className="mb-4">
    <FormLabel>{label}</FormLabel>
    <TwInputDateTime value={value} onChange={onChange} />
  </div>
}


export const ColorPicker = ({ label, value, onChange }) => {
  return <div className="mb-4">
    <FormLabel>{label}</FormLabel>
    {/* <TwInputColor value={value} onChange={onChange} /> */}
  </div>
}

export const SearchDateBox = ({ label, value, onChange, width, onEnter = null }) => {
  const onChangeText = (e) => {
    if (e.includes('_')) {
      onChange(undefined);
    }
    else {
      onChange(e);
    }
  }
  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      onEnter();
    }
  }
  return <div className="mb-4">
    <FormLabel>{label}</FormLabel>
    <TwInputDate
      value={value}
      onChange={onChangeText}
      placeholder={''}
      width={width}
      onKeyDown={onKeyDown}
    />
    {/* <TwInputDate value={value} onChange={onChange} /> */}
  </div>
}

export const TypeSelect = ({ label, value, onChange }) => {
  return <div className="mb-4">
    <FormLabel>{label}</FormLabel>
    {/* <TwInputDate value={value} onChange={onChange} /> */}
  </div>
}

export const TextList = ({ label, value, onChange }) => {
  return <div className="mb-4">
    <FormLabel>{label}</FormLabel>
    {/* <TwInputDate value={value} onChange={onChange} /> */}
  </div>
}